import { TrainingStatistics } from '../../api/ester-b2b-api/private/trainings/types'
import { ChartData } from '../../components/charts/type'

export const getTrainingData = (
  trainingData: TrainingStatistics,
  numberOfEmployees: number,
  t: (key: string) => string
) => {
  const completedTrainings = trainingData.completed
  const startedTrainings = trainingData.inProgress
  const uncompletedTrainings = numberOfEmployees - completedTrainings - startedTrainings

  const chartData: ChartData[] = [
    {
      name: t('common.statistics.trainingCompleted'),
      value: completedTrainings,
      color: '#4DBA99',
    },
    {
      name: t('common.statistics.trainingInProgress'),
      value: startedTrainings,
      color: '#AB91CE',
    },
    {
      name: t('common.statistics.trainingNotStarted'),
      value: uncompletedTrainings,
      color: '#EF643A',
    },
  ]

  return chartData
}
